"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcContractServices = class UcContractServices extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    filterItems(...args) {
        return _.sortBy(args[0], p => this.isServiceStale(p) ? "_" + p.name : p.id);
    }
    isServiceStale(...args) {
        const [service] = args;
        return service.valid_to && this.$fn.parseISODate(service.valid_to) < this.today;
    }
    contract;
    onContract(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("contract");
    }
    readonly;
    onReadonly(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("readonly");
    }
    today;
    async $$load_today() {
        return new Date();
    }
    displayHelper;
    ux;
    b_5917154787680107_style;
    dataMembers = ['today', 'displayHelper', 'ux', 'b_5917154787680107_style'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                today: null,
                displayHelper: null,
                ux: null,
                b_5917154787680107_style: {
                    "min-width": 0,
                },
            },
        };
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_8320016629450276_emit_9018_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_8320016629450276_close_9017_getWhen($event) {
        return !!$event.data.modalResult.ok;
    }
    async act_8320016629450276_showModal_9016_getActionArgs($event) {
        return {
            name: "ContractServiceEditor",
            props: {
                mode: "addService",
                contract: this.contract,
            },
        };
    }
    async evh_8320016629450276_clickPreventStop(event, scope) {
        return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_294572930540096_emit_9022_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_294572930540096_close_9021_getWhen($event) {
        return !!$event.data.modalResult.ok;
    }
    async act_294572930540096_showModal_9020_getActionArgs($event) {
        return {
            name: "ContractServiceEditor",
            props: {
                mode: "editService",
                contract: this.contract,
                service: _.cloneDeep($event.scope.service),
            },
        };
    }
    async evh_294572930540096_clickPreventStop(event, scope) {
        return await this.actions.evh_294572930540096_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_6027561141562583_emit_9024_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_6027561141562583_reload(event, scope) {
        return await this.actions.evh_6027561141562583_reload.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_9014 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_9013 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_9014,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_9013],
        });
        const act_8320016629450276_emit_9018 = new core_1.actions.EmitAction({
            actionArgs: this.act_8320016629450276_emit_9018_getActionArgs,
            displayName: "emitReload",
            events: [],
        });
        const evh_8320016629450276_close_9017 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_emit_9018,
            event: "close",
            when: this.evh_8320016629450276_close_9017_getWhen,
            displayName: "emitReload",
        });
        const act_8320016629450276_showModal_9016 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8320016629450276_showModal_9016_getActionArgs,
            events: [evh_8320016629450276_close_9017],
        });
        const evh_8320016629450276_clickPreventStop_9015 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_showModal_9016,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_8320016629450276_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_clickPreventStop_9015],
        });
        const act_294572930540096_emit_9022 = new core_1.actions.EmitAction({
            actionArgs: this.act_294572930540096_emit_9022_getActionArgs,
            displayName: "emitReload",
            events: [],
        });
        const evh_294572930540096_close_9021 = new core_1.actions.EventHandlerImpl({
            action: act_294572930540096_emit_9022,
            event: "close",
            when: this.evh_294572930540096_close_9021_getWhen,
            displayName: "emitReload",
        });
        const act_294572930540096_showModal_9020 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_294572930540096_showModal_9020_getActionArgs,
            events: [evh_294572930540096_close_9021],
        });
        const evh_294572930540096_clickPreventStop_9019 = new core_1.actions.EventHandlerImpl({
            action: act_294572930540096_showModal_9020,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_294572930540096_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_294572930540096_clickPreventStop_9019],
        });
        const act_6027561141562583_emit_9024 = new core_1.actions.EmitAction({
            actionArgs: this.act_6027561141562583_emit_9024_getActionArgs,
            displayName: "emitReload",
            events: [],
        });
        const evh_6027561141562583_reload_9023 = new core_1.actions.EventHandlerImpl({
            action: act_6027561141562583_emit_9024,
            event: "reload",
            displayName: "emitReload",
        });
        const evh_6027561141562583_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6027561141562583_reload_9023],
        });
        return {
            act_7315092382398562_reloadComponentData_9014,
            evh_7315092382398562_reload_9013,
            evh_7315092382398562_reload,
            act_8320016629450276_emit_9018,
            evh_8320016629450276_close_9017,
            act_8320016629450276_showModal_9016,
            evh_8320016629450276_clickPreventStop_9015,
            evh_8320016629450276_clickPreventStop,
            act_294572930540096_emit_9022,
            evh_294572930540096_close_9021,
            act_294572930540096_showModal_9020,
            evh_294572930540096_clickPreventStop_9019,
            evh_294572930540096_clickPreventStop,
            act_6027561141562583_emit_9024,
            evh_6027561141562583_reload_9023,
            evh_6027561141562583_reload,
            emitReload: act_6027561141562583_emit_9024,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcContractServices.prototype, "contract", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('contract'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcContractServices.prototype, "onContract", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], UcContractServices.prototype, "readonly", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('readonly'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcContractServices.prototype, "onReadonly", null);
UcContractServices = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcContractServices);
exports.default = UcContractServices;
vue_property_decorator_1.Vue.component("UcContractServices", UcContractServices);
